import ScheduleVoteCard from "../schedule-vote-card/ScheduleVoteCard";

const DEFAULT_TEAM_LOGO_SVG = encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
    <rect width="120" height="120" rx="24" fill="#111827"/>
    <circle cx="60" cy="46" r="18" fill="#D1FAE5"/>
    <path d="M30 93c0-14 13-24 30-24s30 10 30 24v3H30v-3z" fill="#A7F3D0"/>
    <text x="60" y="112" text-anchor="middle" fill="#F8FAFC" font-family="Arial, sans-serif" font-size="10" font-weight="700">AH SHOOT</text>
  </svg>`,
);

const DEFAULT_TEAM_LOGO_URL = `data:image/svg+xml;utf8,${DEFAULT_TEAM_LOGO_SVG}`;

function getRoleLabel(role) {
  if (role === "CHAIR") {
    return "회장";
  }
  if (role === "STAFF") {
    return "운영진";
  }
  return "회원";
}

function UserScheduleCard({
  team,
  schedule,
  currentUserId,
  onVote,
  isVoting,
  onOpenTeam,
}) {
  return (
    <article className="rounded-[28px] border border-[#dbe4f4] bg-white/92 p-4 shadow-[0_18px_38px_rgba(15,23,42,0.08)]">
      <button
        type="button"
        onClick={() => onOpenTeam(team.id)}
        className="flex w-full items-center gap-3 rounded-2xl border border-[#e4e7ec] bg-[#f8fafc] px-3 py-3 text-left transition hover:bg-white"
      >
        <img
          src={team.logoUrl || DEFAULT_TEAM_LOGO_URL}
          alt={`${team.name} 로고`}
          className="h-12 w-12 rounded-2xl border border-[#d0d5dd] object-cover"
          onError={(event) => {
            event.currentTarget.src = DEFAULT_TEAM_LOGO_URL;
          }}
        />
        <div className="min-w-0 flex-1">
          <p className="m-0 truncate text-sm font-bold text-[#101828]">
            {team.name}
          </p>
          <p className="mt-1 text-xs text-[#667085]">
            회장 {team.chair} | 내 권한 {getRoleLabel(team.role)}
          </p>
        </div>
        <span className="rounded-full bg-[#111827] px-2.5 py-1 text-[11px] font-semibold text-white">
          팀 이동
        </span>
      </button>

      <div className="mt-3">
        <ScheduleVoteCard
          schedule={schedule}
          currentUserId={currentUserId}
          onOpenDetail={() => onOpenTeam(team.id)}
          onVote={onVote}
          isVoting={isVoting}
        />
      </div>
    </article>
  );
}

export default UserScheduleCard;
